import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import * as HttpStatus from 'http-status-codes';
import * as $ from 'jquery';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { BookingsService } from '../../services/bookings.service';
import { MainService } from '../../services/main.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.scss'],
})
export class BookingsComponent implements OnInit {
  API = this.helper.getApi();
  bookingDeleted = false;
  bookings = [];
  bookingPage: Array<object> = [];
  activePage: number = 1;
  selectedBooking: string;
  showMobBookingDetails: string;
  showDelete = true;
  totalPages = 0;
  currentBooking = [];
  arrowLeftIcon = 'assets/icons/arrow-l.svg';
  arrowRightIcon = 'assets/icons/arrow-r.svg';
  delete = 'assets/icons/close-green.svg';
  superClinicId: string;
  preselectedClinic: string;
  type: string;
  service: string;
  singleClinic: string;
  show: boolean;
  JSON: any = JSON;
  loading: boolean = false;
  currentUser: any = this.helper.getStorage('currentUser');
  allClinics: Array<any> = this.helper.getStorage('allClinics');
  currentPage: any[] = [];
  readonly bodyParts: any = Constants.BODY_PARTS;
  readonly months: any = Constants.MONTHS;
  readonly PAGE_SIZE: number = Constants.BOOKING_PAGINATION_SIZE;
  readonly clinicType: any = Constants.CLINIC_TYPE;

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    public bookingsService: BookingsService,
    public mainService: MainService
  ) {}

  ngOnInit() {
    this.getBookings();

    const userClinic = this.allClinics.filter(
      (clinic) =>
        clinic.id.toLowerCase() === this.currentUser.data.clinicId.toLowerCase()
    );

    this.route.queryParams.subscribe((params: Params) => {
      this.preselectedClinic = params['clinics'];
      this.superClinicId = params['superClinicId'];
      this.type = params['type'];
      this.service = params['service'];
      this.singleClinic = params['singleClinic'];
    });

    if (userClinic.length === 0) {
      console.error('no user clinic');
    }
  }

  export(booking) {
    this.helper.exportPDF(booking);
  }

  getBookings() {
    let clinic = null;

    this.route.queryParams.subscribe((params: Params) => {
      if (params['singleClinic'] === 'true') {
        clinic = params['clinics'];
      }

      if (params['superClinicId']) {
        clinic = params['superClinicId'];
      }
    });

    const bookingData = {
      client: this.currentUser.data.complimentaId,
      clinic: clinic,
      from: '2019-01-01 00:00:00', // get bookings from this date
      to: '2500-01-01 00:00:00', // get bookings up to this date
      activePage: this.activePage,
      bookingsToShow: this.PAGE_SIZE,
    };

    this.bookingsService
      .getBookings(bookingData, this.clinicType.single)
      .subscribe(this.handleBookingsSuccess.bind(this));
  }

  handleBookingsSuccess(bookingsResponse) {
    if (bookingsResponse.status === HttpStatus.OK) {
      const bookings = bookingsResponse.response;

      if (bookings.length > 0) {
        this.transformBookings(bookings);
      }
    } else {
      this.bookings = [];
    }
  }

  transformBookings(response) {
    const today = new Date('2018-01-29T09:45:00');
    const bookings = [];

    this.loading = true;

    response.map((booking) => {
      _.extend(booking, { _id: booking.booking });
    });

    this.bookings = response.filter((booking) => booking.booking);

    localStorage.setItem('bookings', JSON.stringify([]));

    const clinicIds = [];
    const therapistResponses = [];

    this.bookings.map((booking) => {
      if (clinicIds.indexOf(booking.clinic) === -1) {
        clinicIds.push(booking.clinic);
      }
    });

    clinicIds.map((clinicId) => {
      therapistResponses.push(this.mainService.getTherapists(clinicId, null));
    });

    forkJoin(therapistResponses).subscribe((allTherapistResponses) => {
      const therapists = [];

      allTherapistResponses.map((therapistResponse) => {
        therapistResponse['response'].map((therapist) => {
          therapists.push(therapist);
        });
      });

      this.bookings.map((booking) => {
        this.handleTransformBooking(booking, bookings, therapists, today);
      });
    });
  }

  handleTransformBooking(booking, bookings, therapists, today) {
    try {
      booking.comment = JSON.parse(booking.comment);
      booking.validBookingDetails = true;
    } catch (e) {
      booking.comment = {
        comment: booking.comment,
        behandling: '',
        bodyparts: '',
        insurance: '',
        treatment: '',
      };

      booking.validBookingDetails = false;
    }

    this.arrangeBodyParts(booking);

    const selected_therapist = therapists.filter(
      (therapist) => therapist.id === booking.therapist.toLowerCase()
    )[0];

    if (selected_therapist) {
      booking.therapistData = selected_therapist;
      booking.clinicData = this.allClinics.filter(
        (el2) => selected_therapist.clinic_id === el2.id
      )[0];
    }

    booking.date =
      booking.from.substring(8, 10) +
      ' ' +
      this.months[parseInt(booking.from.substring(5, 7))] +
      ' ' +
      booking.from.substring(0, 4);
    booking.dateHeader =
      booking.from.substring(8, 10) +
      ' ' +
      this.months[parseInt(booking.from.substring(5, 7))] +
      ' ' +
      booking.from.substring(0, 4) +
      ' - ' +
      booking.from.substring(11, 16);

    const checkDate = this.helper.reformatDate(booking.from);
    const todayWithGrace = new Date(today);

    if (booking.clinicData) {
      todayWithGrace.setDate(
        today.getDate() + booking.clinicData.bookings_grace_period
      );

      if (checkDate >= todayWithGrace)
        _.extend(booking, { isAllowedDelete: true });
      else _.extend(booking, { isAllowedDelete: false });
    }

    if (bookings.filter((booking1) => booking1.booking !== booking.booking)) {
      bookings.push(booking);
    }

    this.bookings = bookings
      .filter((booking) => booking.clinicData && booking.therapistData)
      .reverse();

    this.calcTotalPages(this.bookings);

    this.currentPage = this.bookings.slice(0, this.PAGE_SIZE);

    localStorage.setItem('bookings', JSON.stringify(bookings));

    this.loading = false;
  }

  arrangeBodyParts(booking) {
    let newElements = [];

    if (
      booking.comment &&
      booking.comment.bodyparts &&
      booking.comment.bodyparts.indexOf(',') > -1
    ) {
      newElements = [];

      const parts = booking.comment.bodyparts.split(',');

      this.bodyParts.map((part) => {
        if (parts.includes(part.index)) {
          newElements.push(part.name);
        }
      });

      booking.comment.bodyparts = newElements.join(', ');
    } else {
      this.bodyParts.map((part) => {
        if (booking.comment.bodyparts == part.index)
          booking.comment.bodyparts = part.name;
      });
    }
  }

  selectBooking(booking: any) {
    this.currentBooking = [];
    this.selectedBooking = booking;
    this.showMobBookingDetails = booking._id;

    this.currentBooking.push(booking);

    const currentTime = new Date();
    const bookingTime = this.helper.reformatDate(this.currentBooking[0].from);

    const cancelPeriod = this.helper.cancelPeriod(
      bookingTime,
      currentTime,
      this.currentBooking[0]
    );

    if (this.currentBooking[0].clinicData.cancelation_period) {
      if (cancelPeriod) {
        this.showDelete = true;
      } else {
        this.showDelete = false;
      }
    } else {
      this.showDelete = true;
    }
  }

  deleteBooking(booking: any) {
    this.bookings = _.reject(this.bookings, function (obj) {
      return obj._id == booking._id;
    });

    const clinic = this.allClinics.filter(
      (clinic) => clinic.id === booking.clinicData.id
    )[0];
    const user = this.currentUser;

    booking['user'] = user.data.complimentaId;
    booking['clinicName'] = clinic.name;
    booking['clinicAddress'] = clinic.address;
    booking['clinicCity'] = clinic.city;
    booking['clinicPost'] = clinic.post_code;
    booking['clinicRegion'] = clinic.region;
    booking['clinicPhone'] = clinic.phone;
    booking['clientName'] = user.data.firstName;
    booking['flow_url'] = window.location.search;

    this.bookingsService.deleteBooking(booking).subscribe(() => {
      this.handleDeleteSuccess();
    });
  }

  handleDeleteSuccess() {
    this.loading = true;
    this.show = false;
    this.currentBooking = [];

    localStorage.setItem('bookings', JSON.stringify(this.bookings));

    this.currentPage = this.sliceBookings(this.bookings, this.activePage);

    if (this.currentPage.length === 0) {
      this.activePage = this.activePage - 1;
      this.totalPages = this.totalPages - 1;

      this.currentPage = this.sliceBookings(this.bookings, this.activePage);
    }

    this.calcTotalPages(this.bookings);

    this.loading = false;
  }

  calcTotalPages(bookings) {
    this.totalPages = Math.ceil(bookings.length / this.PAGE_SIZE);

    if (this.totalPages < 1) {
      this.totalPages = 1;
    }
  }

  sliceBookings(bookings, activePage) {
    const start = activePage * this.PAGE_SIZE - this.PAGE_SIZE;
    let end = start + this.PAGE_SIZE;

    if (end > this.bookings.length) {
      end = this.bookings.length;
    }

    return bookings.slice(start, end);
  }

  openDeletePopup() {
    this.show = true;
  }

  closeDeletePopup() {
    this.show = false;
  }

  navigatePage(direction: any) {
    this.activePage += direction;

    if (this.activePage === 1) {
      this.currentPage = this.bookings.slice(0, this.PAGE_SIZE);
    } else {
      const start = this.activePage * this.PAGE_SIZE - this.PAGE_SIZE;
      let end = start + this.PAGE_SIZE;

      if (end > this.bookings.length) {
        end = this.bookings.length;
      }

      this.currentPage = this.bookings.slice(start, end);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/bookings/bookings.component.ts